import { FunctionComponent } from 'react';

import { Tooltip as RadixTooltip, TooltipProps } from '@radix-ui/themes';

export const Tooltip: FunctionComponent<TooltipProps> = (
  props: TooltipProps
) => {
  return <RadixTooltip {...props} />;
};
